/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignableUser } from './AssignableUser';
import {
    AssignableUserFromJSON,
    AssignableUserFromJSONTyped,
    AssignableUserToJSON,
    AssignableUserToJSONTyped,
} from './AssignableUser';

/**
 * 
 * @export
 * @interface GetAssignableUsers200Response
 */
export interface GetAssignableUsers200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetAssignableUsers200Response
     */
    success?: boolean;
    /**
     * 
     * @type {Array<AssignableUser>}
     * @memberof GetAssignableUsers200Response
     */
    data?: Array<AssignableUser>;
}

/**
 * Check if a given object implements the GetAssignableUsers200Response interface.
 */
export function instanceOfGetAssignableUsers200Response(value: object): value is GetAssignableUsers200Response {
    return true;
}

export function GetAssignableUsers200ResponseFromJSON(json: any): GetAssignableUsers200Response {
    return GetAssignableUsers200ResponseFromJSONTyped(json, false);
}

export function GetAssignableUsers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssignableUsers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AssignableUserFromJSON)),
    };
}

export function GetAssignableUsers200ResponseToJSON(json: any): GetAssignableUsers200Response {
    return GetAssignableUsers200ResponseToJSONTyped(json, false);
}

export function GetAssignableUsers200ResponseToJSONTyped(value?: GetAssignableUsers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AssignableUserToJSON)),
    };
}

